import React from 'react';

const VolvoLogo: React.FC = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 524.06 45.51"
    width="98px"
  >
    <polygon
      fill="currentColor"
      points="52.98 7.69 61.52 7.69 47.24 34.1 32.77 7.7 43.15 7.69 43.14 1.12 .25 1.12 .24 7.7 10.06 7.7 30.01 43.94 53.11 43.96 72.72 7.69 82.55 7.7 82.55 1.12 52.98 1.12 52.98 7.69"
    />
    <path
      fill="currentColor"
      d="M275.09,37.27h-9.13V7.68h9.85V1.13h-39.56v6.55h9.96v29.6h-9.96v6.63h59.38v-19.82h-6.53c0,7.59-5.55,13.18-14.01,13.18h0Z"
    />
    <path
      fill="currentColor"
      d="M154.33.22c-19.86,0-30.41,9.91-30.41,22.34s10.16,22.66,30.53,22.66,30.41-10.05,30.41-22.66S174.2.22,154.33.22ZM164.93,22.67c-.14,7.78-3.35,15.88-10.82,15.74-7.25-.13-10.44-8.15-10.3-16.11.14-8.25,4.09-15.44,10.89-15.33,6.8.12,10.38,7.45,10.24,15.7,0,0,0,0,0,0Z"
    />
    <polygon
      fill="currentColor"
      points="392.03 7.69 400.57 7.69 386.29 34.1 371.82 7.7 382.2 7.69 382.2 1.12 339.3 1.12 339.29 7.7 349.11 7.7 369.06 43.94 392.16 43.96 411.77 7.69 421.6 7.7 421.6 1.12 392.03 1.12 392.03 7.69"
    />
    <path
      fill="currentColor"
      d="M493.39.22c-19.86,0-30.41,9.91-30.41,22.34s10.16,22.66,30.53,22.66,30.41-10.05,30.41-22.66S513.26.22,493.39.22ZM503.99,22.67c-.14,7.78-3.35,15.88-10.82,15.74-7.25-.13-10.44-8.15-10.3-16.11.14-8.25,4.09-15.44,10.89-15.33,6.8.12,10.38,7.45,10.24,15.7,0,0-.01,0-.01,0Z"
    />
  </svg>
);

export default VolvoLogo;
